import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useDroneAreasContext } from 'src/contexts/drone-areas.context';
import { actionTypes } from 'src/ducks/drone-areas.duck';
import { IDroneAreas, IDroneAreasForm } from 'src/models/drone-areas.model';
import { getDroneAreasStatus } from 'src/selectors/drone-areas.selector';
import style from '../drone-areas-list/drone-areas-list.module.scss';
import DroneAreasForm from '../drone-areas-form/drone-areas-form.component';

const DroneAreasAdd: React.FC = () => {
  const { state, actions } = useDroneAreasContext();
   const [isAddOpen, setIsAddOpen] = useState(false);
   const [isDirty, setIsDirty] = useState(false);
   const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IDroneAreas> = {
    SensitiveCityLocation: '',
  };

  const addStatus = getDroneAreasStatus(state, actionTypes.DRONE_AREAS_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
        const formData: IDroneAreasForm = {
          SensitiveCityLocation: data?.SensitiveCityLocation,
        };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_DRONE_AREAS_ADD_SUCCESS,
            formData.SensitiveCityLocation ? formData.SensitiveCityLocation : data.SensitiveCityLocation
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_DRONE_AREAS}
      content={
        <div className={style.content}>
            <DroneAreasForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
            />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default DroneAreasAdd;
